import { b as c, P as n, D as i, r as u } from "./export-cdcbfb2b.js";
var y = c, b = n, p = function(r, o, e) {
  try {
    return y(b(Object.getOwnPropertyDescriptor(r, o)[e]));
  } catch {
  }
}, f = i, v = function(r) {
  return f(r) || r === null;
}, l = v, P = String, _ = TypeError, j = function(r) {
  if (l(r))
    return r;
  throw new _("Can't set " + P(r) + " as a prototype");
}, T = p, O = i, $ = u, h = j, E = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var r = !1, o = {}, e;
  try {
    e = T(Object.prototype, "__proto__", "set"), e(o, []), r = o instanceof Array;
  } catch {
  }
  return function(t, s) {
    return $(t), h(s), O(t) && (r ? e(t, s) : t.__proto__ = s), t;
  };
}() : void 0);
export {
  E as o
};
